"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyRegistrationNumberSchema = void 0;
var _zod = require("zod");
var companyRegistrationNumberSchema = () => {
  return _zod.z.object({
    companyRegistrationNumber: _zod.z.string().min(1, {
      message: 'Invalid company registration number, please try again.'
    })
  });
};
exports.companyRegistrationNumberSchema = companyRegistrationNumberSchema;